var map = {
	"./default.svg": "4419",
	"./fortmatic.svg": "f786",
	"./frame.svg": "3438",
	"./gnosis.svg": "9022",
	"./imtoken.svg": "5bc1",
	"./metamask.svg": "3ed1",
	"./ontowallet.svg": "308c",
	"./portis.svg": "d25c",
	"./status.svg": "3ac9",
	"./trustwallet.svg": "edeb",
	"./walletconnect.svg": "ffed",
	"./walletlink.svg": "2683a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1ea";